import * as SettingsActionTypes from 'actiontypes/settings';
import SettingsService from 'services/SettingsService';
import { Dispatch } from 'redux';
import { ISettingsService } from 'types/settings';

export const fetchSettingsRequested = () => ({
  type: SettingsActionTypes.FETCH_SETTINGS_REQUESTED,
  isFetching: true,
});

export const fetchSettingsSuccess = (response: any) => ({
  type: SettingsActionTypes.FETCH_SETTINGS_SUCCESS,
  isFetching: false,
  data: response,
});

export const fetchSettingsFailure = (error: any) => ({
  type: SettingsActionTypes.FETCH_SETTINGS_FAILURE,
  isFetching: false,
  error: true,
  status: error.response && error.response.status,
});

/** ----------------------------------------------------------------------------
 * FETCH
 -----------------------------------------------------------------------------*/

export default fetch(new SettingsService());

export function fetch(service: ISettingsService) {
  return () => (dispatch: Dispatch) => {
    dispatch(fetchSettingsRequested());

    return service.fetch().then(
      (response: any) => dispatch(fetchSettingsSuccess(response.data)),
      (error: any) => dispatch(fetchSettingsFailure(error)),
    );
  };
}